export const ACCOUNTS = [
  'Astronomy Picture of the Day',
  'Earth Polychromatic Imaging Camera',
  'National Aeronautics and Space Administration',
  'Mars Rover Photos',
  'Earth Photos'
];
